var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',{attrs:{"nav-items":[],"side-items":_vm.sideitems}})
}
var staticRenderFns = []

export { render, staticRenderFns }